import { useIsMobile } from "@/hooks";
import { useTranslation } from "react-i18next";
import IAirline from "@/interfaces/IAirline";
import CustomIcon from "../CustomIcon/CustomIcon";
import Image from "next/image";

interface IAirlineItemProps{
  airlineItem: IAirline;
}

const AirlineItem: React.FC<IAirlineItemProps> = ({ airlineItem }: IAirlineItemProps) => {
  const [isMobile, isTablet, _] = useIsMobile();
  const { t } = useTranslation();

  const logo = isMobile ? airlineItem?.logo?.mobile : airlineItem?.logo?.web;

  function terminalFilter(terminals: string[]) {
    const root = process.env.NEXT_PUBLIC_IATA_AIRPORT_REFERENCE?.toUpperCase() ?? "";
    const cleaned = terminals
      .filter((terminal: string) => terminal.indexOf(root) === 0)
      .map((terminal) => terminal.replace(root + ".", ""));
    return cleaned.length > 1 ? `${cleaned[0]}-${cleaned[1]}` : cleaned[0];
  }

  return (
    <div className={`flex gap-2 desk:items-center border-b border-b-darkgrey relative pb-14 desk:p-0 text-center ${isMobile || isTablet ? "items-center" : ""}`}>
      <div className="w-1/3 desk:w-1/5 flex flex-col items-center">
  
          <Image
            src={logo ||'https://upload.wikimedia.org/wikipedia/commons/0/0b/Air_Company_logo.png'}
            alt={airlineItem.airlineDescription ? `Logo ${airlineItem.airlineDescription}` : "Logo compagnia aerea"}
            width={175}
            height={45}
            sizes="(max-width: 1024px) 33vw, 20vw"
            unoptimized
          />
        
        <div className="desk:hidden">{airlineItem.airlineDescription}</div>
      </div>

      <div className="hidden desk:text-lg text-base desk:w-1/5 desk:block">{airlineItem.airlineDescription}</div>
      <div className="w-1/3 desk:text-lg text-base desk:w-1/5">{airlineItem.airlineIata}</div>
      <div className="w-1/3 desk:text-lg text-base desk:w-1/5">
        {airlineItem.terminal && airlineItem.terminal.length ? terminalFilter(airlineItem.terminal) : ""}
      </div>

      <div className={`desk:flex right-0 ${isMobile || isTablet ? "bottom-3 absolute" : ""} desk:justify-end desk:w-1/5 font-bold`}>
        {airlineItem.websiteUrl ? (
          <a className="desk:text-lg text-base flex items-center gap-2" href={airlineItem.websiteUrl} target="_blank" rel="noopener noreferrer">
            {t("airlines.goToWebSite")} <CustomIcon iconName="chevron-r" />
          </a>
        ) : null}
      </div>
    </div>
  );
};

export default AirlineItem;
